import type { VenueDTO } from '../../types'
import { DataTable } from '../DataTable/DataTable'
import type { ColumnDef } from '../DataTable/DataTable'
import { Badge } from '../Badge/Badge'
import { formatDate } from '../../helpers/formatDate'
import { getVenueStatusBadgeColor } from '../../helpers/getVenueStatusBadgeColor'
import type { VenuesTableProps } from './VenuesTable.types'

const columns: ColumnDef<VenueDTO>[] = [
  {
    header: 'ID',
    sortValue: (v) => v.id,
    accessor: (v) => v.id,
    className: 'table-id-col text-end',
    cellClassName: 'font-monospace small',
  },
  {
    header: 'Slug',
    sortValue: (v) => v.venueSlug,
    accessor: (v) => v.venueSlug,
    cellClassName: 'fw-medium',
  },
  {
    header: 'Sys Venue ID',
    sortValue: (v) => v.sysVenueId,
    accessor: (v) => v.sysVenueId,
    cellClassName: 'font-monospace small',
  },
  {
    header: 'Name',
    sortValue: (v) => v.name,
    accessor: (v) => v.name,
  },
  {
    header: 'Status',
    sortValue: (v) => v.status,
    accessor: (v) => (
      <Badge color={getVenueStatusBadgeColor(v.status)}>{v.status}</Badge>
    ),
  },
  {
    header: 'Type',
    sortValue: (v) => v.type,
    accessor: (v) => <Badge color="grey">{v.type}</Badge>,
  },
  {
    header: 'ISP Type',
    sortValue: (v) => v.inventorySystemType,
    accessor: (v) => <Badge color="grey">{v.inventorySystemType}</Badge>,
  },
  {
    header: 'Created',
    sortValue: (v) => v.createdAt,
    accessor: (v) => formatDate(v.createdAt),
  },
  {
    header: 'Updated',
    sortValue: (v) => v.updatedAt,
    accessor: (v) => formatDate(v.updatedAt),
  },
]

export function VenuesTable({ venues, onRowClick }: VenuesTableProps) {
  return (
    <DataTable
      columns={columns}
      data={venues}
      rowKey={(v) => v.id}
      emptyMessage="No venues found."
      onRowClick={onRowClick}
    />
  )
}
